const tr = {
  specialties:{
    attributes:{
      id: 'ID',
      name: 'Nome',
      is_active: 'Ativo',
      appointment_duration: 'Duração padrão das consultas',
      appointment_interval: 'Intervalo entre consultas',
      external_id_ids: 'Unidade IDS',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
    },
    extras:{
      create: 'Nova especialidade',
      edit: 'Editando especialidade',
      show: 'Visualizando especialidade',
      delete: 'Excluir especialidade',
    },
    defSingular: 'Especialidade',
    defPlural: 'Especialidades',
  }
};

export default tr;
